var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    className: "search-nav-menu",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M500.3,467.6L391.8,359.1c28.5-36.6,45.6-82.6,45.6-132.6c0-119.1-96.6-215.7-215.7-215.7S6,107.5,6,226.6 s96.6,215.7,215.7,215.7c55,0,105.2-20.6,143.3-54.5l107.6,107.6c3.8,3.8,8.8,5.7,13.9,5.7s10-1.9,13.9-5.7 C507.9,487.7,507.9,475.3,500.3,467.6z M221.7,403.1c-97.3,0-176.5-79.2-176.5-176.5S124.4,50.1,221.7,50.1s176.5,79.2,176.5,176.5 S319,403.1,221.7,403.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.a7ea85be36f9be6b7c5b217254182809.svg";
export { ForwardRef as ReactComponent };